import { render } from "./letter-pattern-detail.vue?vue&type=template&id=1ed29601"
import script from "./letter-pattern-detail.vue?vue&type=script&lang=js"
export * from "./letter-pattern-detail.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__